// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/CopyrightCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var CopyrightCircleOutlined = function CopyrightCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleOutlinedSvg
  }));
};

CopyrightCircleOutlined.displayName = 'CopyrightCircleOutlined';
export default React.forwardRef(CopyrightCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CopyrightCircleOutlined.js
// module id = 877
// module chunks = 0